import { brandedString } from 'src/helpers/brandedString';

// @todo: Ideally schema would expose them
export const TenantActions = brandedString({
  DELETE: 'tenant-management:tenant.delete',
  READ: 'tenant-management:tenant.read',
  UPDATE_MEMBERS: 'tenant-management:tenant.update-users',
  UPDATE_NAME: 'tenant-management:tenant.update-name',
  UPDATE_ORGANIZATION: 'tenant-management:tenant.update-organization',
});
